import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, InputAdornment, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomAutocomplete from '../../../autocomplete-field';
import { fetchSigns, selectSigns } from '../../../../redux/reducers/OPD/Admin/signsSlice';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

interface Sign {
    _id: string;
    signName: string;
}

export const Examination: React.FC<any> = ({ onChange, data, profile, opdData }) => {
    const [selectedExamination, setSelectedExamination] = useState<Sign[]>([]);
    const [selectedSigns, setSelectedSigns] = useState<{ [key: string]: string }>({});
    const [inputValueSigns, setInputValueSigns] = useState("");
    const [dateTime, setDateTime] = useState<dayjs.Dayjs | null>(dayjs());
    const dispatch = useDispatch();
    const [examination, setExamination] = useState<any[]>([])
    const [doctor_Name, setDoctorName] = useState<any>()
    const allSigns = useSelector(selectSigns) || [];
    const [search, setSearch] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedExaminationForDialog, setSelectedExaminationForDialog] = useState<Sign | null>(null);

    useEffect(() => {
        setExamination(opdData?.signs)
    }, [opdData])
    useEffect(() => {
        dispatch(fetchSigns(inputValueSigns) as any);
    }, [dispatch, inputValueSigns]);

    useEffect(() => {
        if (data?.examinations) {
            setSelectedExamination(data?.examinations || []);
        }
        if (data?.examinations_Without_GPE) {
            setSelectedSigns(data?.examinations_Without_GPE || []);
        }
        if (data?.dateTime) {
            setDateTime(dayjs(data?.dateTime));
        }
        if (data?.doctor_Name) {
            setDoctorName(data?.doctor_Name);
        }
    }, [data]);

    const signs = allSigns?.filter((sign: Sign) =>
        sign?.signName?.toLowerCase().startsWith("gpe")
    );
    const signsWithoutGPE = allSigns?.filter((sign: Sign) =>
        !sign?.signName?.toLowerCase().startsWith("gpe")
    );

    useEffect(() => {
        setDoctorName(profile?.data?.fullName)
    }, [profile])

    useEffect(() => {
        dispatch(fetchSigns(inputValueSigns) as any);
    }, [dispatch, inputValueSigns]);

    const handleSignsTextChange = (signName: string, newDetails: string) => {
        setSelectedSigns((prevSigns: any) => ({
            ...prevSigns,
            [signName]: newDetails,
        }));
    };

    const deleteTheSigns = async (signName: string) => {
        setSelectedSigns((prevSigns: any) => {
            const updatedSigns = { ...prevSigns };
            delete updatedSigns[signName];
            return updatedSigns;
        });
    };

    const handleSelectChangeSign = (event: React.ChangeEvent<{}>, newValue: Sign[]) => {
        const existingSignNames = new Set(selectedExamination?.map((sign: any) => sign) || []);
        const updatedSigns = newValue?.reduce((acc: any[], sign: any) => {
            if (sign?.signName && !existingSignNames?.has(sign?.signName)) {
                acc.push(sign?.signName);
            }
            return acc;
        }, []);
        const finalExamSigns = [...selectedExamination, ...updatedSigns];
        setSelectedExamination(finalExamSigns);

        setInputValueSigns('');
    };

    // const handleSelectChangeSignWithOutGPE = (event: any, newValue: any) => {
    //     const existingSignNames = new Set(Object.keys(selectedSigns || {}));
    //     const updatedSigns = newValue?.reduce((acc: any, sign: any) => {
    //         if (sign?.signName && !existingSignNames?.has(sign?.signName)) {
    //             acc[sign?.signName] = '';
    //         }
    //         return acc;
    //     }, {});
    //     const finalSigns = { ...selectedSigns, ...updatedSigns };
    //     setSelectedSigns(finalSigns);
    //     setSearch(newValue)

    //     setInputValueSigns('');
    // };

    const handleSelectChangeSignWithOutGPE = (event: any, newValue: any) => {
        const existingSignNames = new Set(Object.keys(selectedSigns || {}));

        const signAlreadyExists = newValue.some((sign: Sign) => opdData?.signs?.includes(sign?.signName));

        if (signAlreadyExists) {
            setSelectedExaminationForDialog(newValue[0]);
            setOpenDialog(true);
        } else {
            const updatedSigns = newValue?.reduce((acc: any, sign: any) => {
                if (sign?.signName && !existingSignNames?.has(sign?.signName)) {
                    acc[sign?.signName] = '';
                }
                return acc;
            }, {});
            const finalSigns = { ...selectedSigns, ...updatedSigns };
            setSelectedSigns(finalSigns);
            setSearch(newValue);
            setInputValueSigns('');
        }
    };

    const handleDialogClose = (confirm: boolean) => {
        if (confirm && selectedExaminationForDialog) {
            setSelectedSigns((prevSigns: any) => ({
                ...prevSigns,
                [selectedExaminationForDialog?.signName]: '',
            }));
        }
        setOpenDialog(false);
        setInputValueSigns('');
    };
    useEffect(() => {
        onChange({
            examinations: selectedExamination,
            examinations_Without_GPE: selectedSigns,
            opd_Examination: examination,
            doctor_Name,
            dateTime: dateTime,
        });
    }, [selectedExamination, selectedSigns, dateTime, selectedExamination]);

    const handleDeleteChip = (signToDelete: any) => {
        const updatedExamination = selectedExamination?.filter(
            (sign: any) => sign !== signToDelete
        );
        setSelectedExamination(updatedExamination);
    };

    const handleInputChangeSigns = (event: any, newInputValue: string) => {
        setInputValueSigns(newInputValue);
    };

    const handleBlurSigns = () => {
        setInputValueSigns('');
    };
    const handleCreateNewSigns = async (inputValue: string) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_OPD_API_URL}/signs/createSign?count=50000`,
                { signName: inputValue },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );
            const newGeneric = response?.data?.data;
            if (newGeneric) {
                dispatch(fetchSigns(inputValueSigns) as any);
                toast.success(response?.data?.message);
            }
        } catch (error: any) {
            toast.error(error.message);
        }
    };
    // const handleCreateNewExamination = async (inputValue: string) => {
    //     try {
    //         const response = await axios.post(
    //             `${process.env.REACT_APP_OPD_API_URL}/signs/createSign?count=50000`,
    //             { signName: inputValue },
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${localStorage.getItem("token")}`,
    //                 },
    //             }
    //         );
    //         const newGeneric = response?.data?.data;
    //         if (newGeneric) {
    //             setSelectedExamination((prevSelected: any) => [...prevSelected, newGeneric]);
    //             dispatch(fetchSigns(inputValueSigns) as any);
    //             toast.success(response?.data?.message);
    //         }
    //     } catch (error: any) {
    //         toast.error(error.message);
    //     }
    // };
const handleCreateNewExamination = async (inputValue: string) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_OPD_API_URL}/signs/createSign?count=50000`,
            { signName: inputValue },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );
        const newGeneric = response?.data?.data;
        if (newGeneric) {
            // Ensure only the `signName` is added to `selectedExamination`
            setSelectedExamination((prevSelected: any) => [
                ...prevSelected,
                newGeneric.signName, // Extract `signName` here
            ]);
            dispatch(fetchSigns(inputValueSigns) as any);
            toast.success(response?.data?.message);
        }
    } catch (error: any) {
        toast.error(error.message);
    }
};
    const handleAddButtonClickSigns = () => {
        if (inputValueSigns?.trim() !== "") {
            handleCreateNewSigns(inputValueSigns);
            setInputValueSigns("");
        }
    };
    const handleAddButtonClickExamination = () => {
        if (inputValueSigns?.trim() !== "") {
            handleCreateNewExamination(inputValueSigns);
            setInputValueSigns("");
        }
    };
    const handleKeyPressSigns = (event: {
        key: string;
        preventDefault: () => void;
    }) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleAddButtonClickSigns();
        }
    };
    const handleKeyPressExamination = (event: {
        key: string;
        preventDefault: () => void;
    }) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleAddButtonClickExamination();
        }
    };
    const prioritizedSigns = ['Abdomen', 'CNS', 'CVS', 'Resp'];

    const sortedSigns = Object.keys(selectedSigns)?.sort((a, b) => {
        const aStartsWithPriority = prioritizedSigns.some(prefix => a.startsWith(prefix));
        const bStartsWithPriority = prioritizedSigns.some(prefix => b.startsWith(prefix));

        if (aStartsWithPriority === bStartsWithPriority) {
            return a.localeCompare(b);
        }
        return aStartsWithPriority ? -1 : 1;
    });

    return (
        <>
            <Box sx={{
                height: { md: '50vh', sm: '100%', xs: '100%' }, overflowY: 'auto'
            }}>
                <Grid container spacing={3}>
                    <Grid item md={3} sm={4} xs={6}>
                        <Box>
                            <CustomAutocomplete
                                multiple
                                options={signs}
                                getOptionLabel={(option) => option?.signName || ""}
                                filterOptions={(options, { inputValue }) =>
                                    options.filter((option: Sign) =>
                                        option?.signName?.toLowerCase().includes(inputValue.toLowerCase())
                                    )
                                }
                                onChange={handleSelectChangeSign}
                                value={selectedExamination}
                                placeholder="Select G.P. Examination"
                                onTextFieldChange={(event) => handleInputChangeSigns(event, event.target.value)}
                                handleBlur={handleBlurSigns}
                                handleAddClick={handleAddButtonClickExamination}
                                onKeyPress={handleKeyPressExamination}
                            />
                        </Box>
                        <Box mt={0.3}>
                            {selectedExamination?.map((sign: any) => (
                                <Chip
                                    key={sign}
                                    label={sign}
                                    onDelete={() => handleDeleteChip(sign)}
                                    sx={{
                                        mr: .4,
                                        background: "#CFCFCF",
                                        borderRadius: "8px",
                                        fontSize: "12px",
                                        height: "24px",
                                        "&:hover": {
                                            background: "#055FFC",
                                            color: "#fff",
                                            "& .MuiChip-deleteIcon": {
                                                color: "#fff",
                                            },
                                            "& .MuiChip-icon": {
                                                color: "#fff",
                                            },
                                        },
                                    }}
                                />
                            ))}
                        </Box>
                    </Grid>
                    <Grid item md={5} sm={4} xs={6}>
                        <CustomAutocomplete
                            options={signsWithoutGPE}
                            getOptionLabel={(option) => option?.signName || ""}
                            filterOptions={(options, { inputValue }) =>
                                options.filter((option: any) =>
                                    option?.signName?.toLowerCase().includes(inputValue.toLowerCase())
                                )
                            }
                            onChange={handleSelectChangeSignWithOutGPE}
                            handleAddClick={handleAddButtonClickSigns}
                            onTextFieldChange={(event) => handleInputChangeSigns(event, event.target.value)}
                            onKeyPress={handleKeyPressSigns}
                            handleBlur={handleBlurSigns}
                            value={search}
                            placeholder="Select Systematic Examination"
                            multiple
                        />

                        {Object.keys(selectedSigns)?.length > 0 && (
                            <Box
                                sx={{
                                    height: '10rem',
                                    background: '#E6EFFF',
                                    border: '2px dotted #055FFC',
                                    mt: 1,
                                    padding: 0.5,
                                    borderRadius: '12px',
                                    overflowY: 'auto',
                                    "&::-webkit-scrollbar": {
                                        width: "3px",
                                    },
                                    "&::-webkit-scrollbar-track": {
                                        background: "transparent",
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                        background: "#888",
                                        borderRadius: "5px",
                                    },
                                    "&::-webkit-scrollbar-thumb:hover": {
                                        background: "#555",
                                    },
                                }}
                            >
                                {/* ?.sort((a: any, b: any) => {
                                        const aName = a?.exam || '';
                                        const bName = b?.exam || '';
                                        if (aName?.startsWith('CNS') && !bName.startsWith('CNS')) return -1;
                                        if (bName?.startsWith('CNS') && !aName.startsWith('CNS')) return 1;
                                        if (aName?.startsWith('CVS') && !bName.startsWith('CVS')) return -1;
                                        if (bName?.startsWith('CVS') && !aName.startsWith('CVS')) return 1;
                                        return aName?.localeCompare(bName);
                                    }) */}
                                {sortedSigns?.map((signName) => (
                                    <Box display="flex" alignItems="center" key={signName} justifyContent="space-between" mt={0.5}>
                                        <Tooltip title={signName} arrow placement="top">
                                            <Typography sx={{ color: '#000', width: '40%', fontSize: '11px' }}>
                                                {signName?.length > 16 ? `${signName?.substring(0, 16)}...` : signName}
                                            </Typography>
                                        </Tooltip>
                                        <TextField
                                            sx={{
                                                width: "90%",
                                                backgroundColor: '#F5F5FB',
                                                borderRadius: '12px',
                                                '& .MuiInputBase-root': {
                                                    height: '24px',
                                                    borderRadius: '12px',
                                                    padding: 0,
                                                    backgroundColor: 'transparent',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                },
                                            }}
                                            value={selectedSigns[signName]}
                                            onChange={(e) => handleSignsTextChange(signName, e.target.value)}
                                            size="small"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <span
                                                            style={{
                                                                color: 'red',
                                                                cursor: 'pointer',
                                                                height: '20px',
                                                                lineHeight: '24px',
                                                            }}
                                                            onClick={() => deleteTheSigns(signName)}
                                                        >
                                                            X
                                                        </span>
                                                    </InputAdornment>
                                                ),
                                                style: {
                                                    fontSize: "12px",
                                                    padding: '0 8px',
                                                },
                                            }}
                                        />
                                    </Box>
                                ))}
                            </Box>
                        )}
                    </Grid>
                    <Grid item md={4} sm={4} xs={6}>
                        <Typography sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}>
                            <b>Previous Examination:</b>  {examination?.join(', ')}
                        </Typography>
                    </Grid>
                </Grid>
            </Box >
            <Box >
                <Grid container spacing={1}>
                    <Grid item md={3} sm={6} xs={12}>
                        <Typography sx={{ fontSize: '14px', fontWeight: '500' }}>Name </Typography>
                        <TextField value={doctor_Name} disabled fullWidth className='search-field' size='small' />
                    </Grid>
                    <Grid item md={3} sm={6} xs={12}>
                        <Typography sx={{ fontSize: '14px', fontWeight: '500' }}>Time </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                value={dayjs(dateTime)}
                                disabled
                                format='DD.MM.YYYY hh:mm A'
                                sx={{
                                    "& fieldset": { border: "none" },
                                    "& .MuiInputBase-root": { height: "38px", fontSize: "12px", overflow: "hidden" },
                                    "& .MuiOutlinedInput-root": { borderRadius: "8px", border: "none", backgroundColor: "#F5F5FB" },
                                    width: "100%",
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>
            </Box>

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Examination aleady Advised</DialogTitle>
                <DialogContent>
                    <Typography>Do you want to advise <span style={{ fontWeight: 'bold', textDecoration:'underline' }}>{selectedExaminationForDialog?.signName}</span> again?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleDialogClose(false)} color="primary">No</Button>
                    <Button onClick={() => handleDialogClose(true)} color="primary">Yes</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
